export const getQueryParamValue = (param: string) => {
    const url = new URL(document.location.href);
    const paramValue = url.searchParams.get(param) || false;
    return paramValue ? paramValue : "";
}

export const removeQueryParams = (params: string[]) => {
    const url = new URL(document.location.href);
    params.forEach((param) => url.searchParams.delete(param));
    window.history.replaceState({}, document.title, url.href);
}

export const removeQueryParam = (param: string) => {
    removeQueryParams([param]);
}

export const setQueryParam = (key: string, value: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
    window.history.pushState({ path: newurl }, '', newurl);
}